// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__17bwS","footer":"ModalInfo_footer__30exN"};